<template>
    <div id="content">
        <div class="container-fluid page-title">
            <div class="container">
                <h1>
                    Quem somos </h1>
                <p class="info">
                    Conheça o Programa Parceiro Simonetti
                </p>
            </div>
        </div>
        <div class="container page-content">
            <div class="row pt-1 m-1">
                <div class="col-md-12 col-sm-12 p-0 text-justify">
                    <img class="float-left mr-3" src="../assets/img/logo-h.png">
                    <p style="font-size: 1.5em; font-weight: 300; padding-top: 5px">
                        <b>
                            Essa é uma modalidade de negócios da Móveis Simonetti, empresa sólida capixaba com cerca de
                            trinta anos de história e mais de sessenta lojas no Brasil.
                        </b>
                    </p>
                </div>
                <div class="col-12 p-0 pt-2 text-justify" style="font-weight: 300">
                    <p>
                        Hoje, a Móveis Simonetti é um sonho que se tornou realidade e atualmente é vista como um dos maiores
                        nomes em bens duráveis do país. Surgiu então o desejo de expandir o seu negócio e alavancar novas
                        parcerias com empreendedores o que originou o <b>Programa Parceiro Simonetti</b>.<br/>
                    </p>
                    <p>
                        Todo o programa é destinado ao Empreendedor que almeja expandir seu mix de produtos, mas não
                        consegue comprar direto com a indústria por motivo de baixo valor disponível para compra ou até mesmo
                        por não necessitar montar grandes estoques.<br/>
                    </p>
                    <p>
                        Em nosso mix de produtos disponibilizamos móveis, eletrodomésticos, eletrônicos e aparelhos de
                        telefonia, sem regras de quantidade mínima para aquisição.<br/>
                    </p>
                    <p>
                        A compra é realizada através do site, totalmente seguro, e a entrega é feita em até no máximo três dias
                        ou se preferir, a mercadoria pode ser retirada em um dos nossos Centros de Distribuição.
                        <br/>
                    </p>
                    <p>
                        <b style="color: #c70000;">Programa Parceiro Simonetti, é rápido, é fácil, é pra você!</b>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {}
</script>



// WEBPACK FOOTER //
// QuemSomos.vue?d35adb98